import { render, staticRenderFns } from "./ActionItemsSection.vue?vue&type=template&id=c7265358&scoped=true&"
import script from "./ActionItemsSection.vue?vue&type=script&lang=js&"
export * from "./ActionItemsSection.vue?vue&type=script&lang=js&"
import style0 from "./ActionItemsSection.vue?vue&type=style&index=0&id=c7265358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7265358",
  null
  
)

export default component.exports